export default {
  data() {
    return {
      showLoading: false, // 列表是否显示加载状态

      listData: [], // 列表数据
      companys: [{ value: '', label: '全部' }], // 收单机构下拉框
      services: [{ value: '', label: '全部' }], // 城市服务商下拉框
      channels: [{ value: '', label: '全部' }], // 渠道下拉框
      listExpands: [{ value: '', label: '全部' }], // 扩展人员下拉框
      paychannels: [{ value: '', label: '全部' }], // 可选通道下拉框

      query: {}, // 查询条件
      pageData: {
        total: 0,
        pageSize: 20,
        currentPage: 1
      } // 翻页页码数据
    }
  },

  methods: {

    // 扩展人员下拉列表
    getListExpand() {
      const { dispatch } = this.$store
      const dispatchEvent = 'selects/getListExpand'
      dispatch(dispatchEvent).then((data) => {
        this.listExpands = data
      })
    },

    // 可选通道下拉列表
    getPaychannels() {
      const { dispatch } = this.$store
      const dispatchEvent = 'selects/getPaychannels'

      dispatch(dispatchEvent).then((data) => {
        this.paychannels = data
      })
    },

    // 收单机构下拉列表
    getCompanyList() {
      const { dispatch } = this.$store
      const dispatchEvent = 'selects/getCompanyList'

      dispatch(dispatchEvent).then((data) => {
        this.companys = data
      })
    },

    // 获取城市服务商
    getServiceList() {
      const { dispatch } = this.$store
      const dispatchEvent = 'selects/getServiceList'

      dispatch(dispatchEvent).then((data) => {
        this.services = data
      })
    },

    // 获取渠道下拉列表
    getChannelList() {
      const { dispatch } = this.$store
      const dispatchEvent = 'selects/getChannelList'

      dispatch(dispatchEvent).then((data) => {
        // console.log(data,'渠道');
        this.channels = data
      })
    },



    // 当点击查询按钮时 将页码重置为 1
    // 且重新获取一次数据
    onClickQuery() {
      this.showLoading = true
      this.pageData.currentPage = 1

      // 不管成功还是失败都取消加载状态
      // 但是前提是需要返回dispatch事件
      this.getListData().finally(() => {
        this.showLoading = false
      })
    },

    // 当切换页码的时候 修改页码数据
    onChangePage(pageNumber) {
      this.showLoading = true
      this.pageData.currentPage = pageNumber

      this.getListData().finally(() => {
        this.showLoading = false
      })
    },
  }
}
